import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/eligibilitySummaryCard.module.scss';
import { STATUS_CONFIG } from '../eligibilitySummaryCard.constants';

/**
 * Eligibility Summary Card KPI
 * @param {string} status - The status of the KPI (low, medium, high)
 * @param {string} label - The label of the KPI
 */
function EiligibilitySummaryCardKpi({ status = 'low', label = 'Reliability' }) {
    const normalizedStatus = String(status).toLowerCase();
    const statusConfig = STATUS_CONFIG[normalizedStatus] || STATUS_CONFIG.low;

    return (
        <div
            className={`${styles.reliabilityBadge} ${statusConfig.className}`}
            aria-label={`${statusConfig.text} ${label}`}
        >
            <svg viewBox="0 0 120 120" role="presentation" focusable="false">
                <circle cx="60" cy="60" r="48" />
            </svg>
            <div className={styles.reliabilityText}>
                <Text as="span" size="l" className={styles.reliabilityStatus}>
                    Stable
                </Text>
                <Text as="span" size="xs" className={styles.reliabilityLabel}>
                    {label}
                </Text>
            </div>
        </div>
    );
}
export default EiligibilitySummaryCardKpi;